import React, { useEffect, useState } from "react";
import { Chip, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../services/api";

const useStyles = makeStyles(() => ({
  chip: {
    fontWeight: "bold",
    color: "#fff",
    cursor: "default",
  },
}));

const STATUS_COLORS = {
  ok: "#4caf50",
  warning: "#ff9800",
  breached: "#f44336",
};

const STATUS_LABELS = {
  ok: "SLA OK",
  warning: "SLA Alerta",
  breached: "SLA Estourado",
};

const SlaIndicator = ({ ticketId, priority, companyId }) => {
  const classes = useStyles();
  const [sla, setSla] = useState(null);

  useEffect(() => {
    if (!ticketId) return;
    let active = true;

    const load = async () => {
      try {
        const { data } = await api.get(`/tickets/${ticketId}/sla`);
        if (active) setSla(data);
      } catch (_) {}
    };

    load();
    const timer = setInterval(load, 60000);
    return () => {
      active = false;
      clearInterval(timer);
    };
  }, [ticketId]);

  if (!sla) return null;

  const remaining = sla.limitMinutes - sla.elapsedMinutes;
  const tooltip =
    sla.slaStatus === "breached"
      ? `Estourado há ${Math.abs(remaining)} min`
      : `Restam ${remaining} min`;

  return (
    <Tooltip title={tooltip} arrow>
      <Chip
        className={classes.chip}
        label={STATUS_LABELS[sla.slaStatus]}
        size="small"
        style={{ backgroundColor: STATUS_COLORS[sla.slaStatus] }}
      />
    </Tooltip>
  );
};

export default SlaIndicator;
